import {connect} from 'react-redux'
import {compose, branch, renderComponent, renderNothing} from 'recompose'
import LeftSidebar from './LeftSidebar'

const layouts = ['default-sidebar-1', 'collapsed-sidebar-1']

const Component = compose(
  connect(state => {
    return {
      auth: state.auth,
      navigation: state.navigation,
      users: state.users,
      layout: state.config.layout,
      menuShow: state.config.menuShow
    }
  }),
  branch(
    ({layout}) => layouts.includes(layout),
    renderComponent(LeftSidebar),
    renderNothing
  )
)(LeftSidebar)

export default Component



// WEBPACK FOOTER //
// ./src/elements/left-sidebar/index.js